import styled from 'styled-components';

/**
 * The two lockups are swapped by CSS off `<html data-ows-theme>`, not by React.
 * the same mechanism the configurator wizard's logo uses (see
 * `pages/configurator-v3/components/wizard/Logo/Logo.styles.ts`). Both `<img>`s
 * stay mounted and the theme toggle is a pure repaint: no re-render, no flash, and
 * the boot script in `index.html` has already stamped the attribute before first
 * paint, so the correct lockup is the one that shows on load.
 *
 * Sizing is deliberately NOT set here. The wrapper keeps the `logo` class name the
 * auth pages' own stylesheets target (`.logo { width: 200px }` plus the
 * `svg, img { width: 100% }` rule and the mobile `max-width` override), so the
 * lockup keeps rendering exactly as it did before it was a component.
 */
export const Lockup = styled.div`
  display: flex;
`;

/** Light-on-dark lockup: the default, shown on the dark theme. */
export const DarkThemeLockup = styled.img`
  display: block;

  :root[data-ows-theme='light'] & {
    display: none;
  }
`;

/** Dark-on-light lockup: shown on the light theme, where the light one vanishes. */
export const LightThemeLockup = styled.img`
  display: none;

  :root[data-ows-theme='light'] & {
    display: block;
  }
`;
